import { getPasswordStrength } from "@/lib/validation";

// Visual strength bar + label shown under any "new password" field.
export function PasswordStrengthMeter({ password }) {
  if (!password) return null;
  const { score, label, color } = getPasswordStrength(password);
  const pct = Math.min(100, (score / 5) * 100);
  const labelColor = label === "Weak" ? "text-red-600" : label === "Fair" ? "text-amber-600" : "text-green-700";
  return (
    <div className="mt-1.5" data-testid="password-strength-meter">
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-slate-100">
        <div className={`h-full rounded-full transition-all duration-300 ${color}`} style={{ width: `${pct}%` }} />
      </div>
      <p className={`mt-1 text-xs font-medium ${labelColor}`}>{label} password</p>
    </div>
  );
}

// Small inline error line reused under any validated field.
export function FieldError({ message, testId }) {
  if (!message) return null;
  return (
    <p data-testid={testId} className="mt-1 text-xs text-red-600">
      {message}
    </p>
  );
}
